import React from 'react';
import { Tooltip, IconButton, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';
import OnOffSwitch from '../OnOffSwitch';
import { toolTipBlue, Grey3 } from '../../../color_utils';
import { trakrefFontFamily } from '../../../utils';

const InfoSwitch = ({
    id,
    label,
    tooltip,
    helperText,
    value,
    onChange,
    disabled = false,
}) => (
    <>
        <OnOffSwitch
            id={id}
            label={
                <span>
                    {label}
                    {tooltip && (
                        <Tooltip
                            arrow
                            title={tooltip}
                            placement="top"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        bgcolor: toolTipBlue,
                                        fontSize: "12px",
                                        fontFamily: trakrefFontFamily,
                                        '& .MuiTooltip-arrow': {
                                            color: toolTipBlue,
                                        },
                                    },
                                },
                            }}
                        >
                            <IconButton
                                aria-label={`About ${label}`}
                                onClick={e => e.preventDefault()}
                                sx={{
                                    ":focus": {
                                        outline: "none",
                                    },
                                    marginLeft: 1
                                }}
                            >
                                <InfoOutlinedIcon fontSize='small' />
                            </IconButton>
                        </Tooltip>
                    )}
                </span>
            }
            value={value}
            onChange={onChange}
            disabled={disabled}
        />
        {helperText && (
            <Typography
                variant="caption"
                sx={{ color: Grey3, fontFamily: trakrefFontFamily, display: "block", mt: "-4px" }}
            >
                {helperText}
            </Typography>
        )}
    </>
);

InfoSwitch.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.node,
    helperText: PropTypes.node,
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default InfoSwitch;
